/* eslint-disable */
let RestTypeEntity = Backbone.Model.extend({
	defaults: {
		id: null,
		name: null,
		nameEn:null,
		description:null
	}
});

export default RestTypeEntity;